<div>
  <h6 class="odx-title-6" i18n="@@floorplan.displayMode.title">Anzeigemodus</h6>
  <form odxForm [formGroup]="displayModeForm">
    <odx-toggle-button-group formControlName="displayMode">
      <odx-toggle-button [value]="FloorplanDisplayMode.SCHEMATIC">
        {{ FloorplanDisplayMode.SCHEMATIC | localizeFloorplanDisplayMode }}
      </odx-toggle-button>
      <odx-toggle-button [value]="FloorplanDisplayMode.PRODUCT_IMAGE">{{
        FloorplanDisplayMode.PRODUCT_IMAGE | localizeFloorplanDisplayMode
      }}</odx-toggle-button>
    </odx-toggle-button-group>
  </form>
  <hr />
</div>
